// Profile save dialog (2026-10-19): the in-app replacement for the browser's alert() / confirm() in the
// Profile save flow, in the same design as LoadBalanceModal ("שים לב — עומס לא מאוזן"). Presentation
// only: the caller decides the text and what each button does — every validation rule, message and
// block stays in Profile.jsx exactly as before.
//   block   — one button ("תקן את הנתונים"): the save stops, the user fixes the form.
//   confirm — "שמור בכל זאת" + "ביטול": the existing overridable warning.
import { WarningCircle } from '@phosphor-icons/react';
import React, { useEffect, useRef } from 'react';

export default function ProfileDialog({ dialog, onClose }) {
  const primary = useRef(null);
  useEffect(() => {
    if (!dialog) return undefined;
    if (primary.current) primary.current.focus();
    const onKey = (e) => { if (e.key === 'Escape') onClose(false); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [dialog, onClose]);
  if (!dialog) return null;
  const isConfirm = dialog.kind === 'confirm';
  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center bg-black/70 px-4" dir="rtl"
         data-testid="profile-dialog">
      <div role="alertdialog" aria-modal="true" aria-labelledby="pf-dialog-title" aria-describedby="pf-dialog-body"
           className="w-full max-w-sm rounded-2xl bg-bg border border-border overflow-hidden">
        <div className="flex justify-center pt-6">
          <div className="w-14 h-14 rounded-2xl bg-pressed border-2 border-border flex items-center justify-center">
            <WarningCircle size={26} weight="bold" className="text-text-body" aria-hidden="true" />
          </div>
        </div>
        <div className="px-6 pt-4 pb-2 text-center">
          <h2 id="pf-dialog-title" className="text-text text-lg font-bold">{dialog.title}</h2>
        </div>
        <div className="px-6 py-3">
          <div id="pf-dialog-body"
               className="rounded-xl bg-pressed border border-border p-4 text-text-body text-sm leading-relaxed whitespace-pre-line text-right">
            {dialog.message}
          </div>
        </div>
        <div className="px-6 pb-6 pt-2 space-y-2">
          <button ref={primary} type="button" onClick={() => onClose(true)}
                  className="w-full py-3 rounded-xl btn-primary">
            {isConfirm ? (dialog.confirmLabel || 'שמור בכל זאת') : 'תקן את הנתונים'}
          </button>
          {isConfirm && (
            <button type="button" onClick={() => onClose(false)}
                    className="w-full py-2.5 rounded-xl border border-border text-text text-sm hover:bg-pressed">
              ביטול
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

/** The browser alert text, minus its leading "⚠️" (the dialog has its own icon). Words unchanged. */
export function dialogText(text) {
  return String(text || '').replace(/^\s*⚠️\s*/, '');
}
